export default {
  GALLERY: "gallery",
  STORY: "story",
  HIGHLIGHTS: "highlights",
  SHOP_THE_LOOK: "shopTheLook",
  MARKETPLACE: "marketplace",
  OUTFIT_ON_MODEL: "outfitOnModel",
};
